// src/components/Events/GlobalSummit.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Events.css';

const GlobalSummit = () => {
  return (
    <div className="global-summit-page">
      {/* ===== HERO SECTION ===== */}
      <div 
        className="global-summit-hero"
        style={{
          backgroundImage: 'url(/images/presidency-villa.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="global-summit-hero-overlay"></div>
        <div className="global-summit-hero-content">
          <span className="global-summit-badge">UPCOMING GLOBAL EVENT</span>
          <h1>AICIS 2026</h1>
          <h2>Global Summit</h2>
          <p className="global-summit-subtitle">
            Africa Infrastructure, Climate Change, Security &amp; Green Investment Summit
          </p>
          <div className="global-summit-stats">
            <div className="stat-item">
              <span className="stat-number">25-28 NOV</span>
              <span className="stat-label">Date</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">Abuja</span>
              <span className="stat-label">Location</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">3,000+</span>
              <span className="stat-label">Participants</span>
            </div>
          </div>
          <div className="global-summit-hero-buttons">
  <Link to="/policy-agreement" className="global-btn primary">
    Register Now
  </Link>
  <Link to="/media-registration" className="global-btn secondary">
    Media Registration
  </Link>
</div>
        </div>
      </div>

      {/* ===== OVERVIEW SECTION ===== */}
      <section className="global-summit-section" id="overview">
        <div className="global-summit-container">
          <div className="global-summit-header">
            <span className="global-summit-section-badge">ABUJA 2026</span>
            <h2>Accelerating Green Investments</h2>
            <div className="global-summit-line"></div>
          </div>
          <div className="global-summit-overview-grid">
            <div className="global-summit-overview-text">
              <p>
                The <strong>AICIS 2026 Global Summit</strong> is the landmark assembly bringing 
                together global heads of state, development finance institutions, global investors, 
                and tech leaders to Abuja, Nigeria. The summit focuses on policy integration, 
                scaling sustainable infrastructure, and unlocking green funding mechanisms for 
                the African continent.
              </p>
              <p>
                Under the theme of sustainable implementation and action, the summit will facilitate 
                direct deal-making rooms and high-level inter-ministerial roundtables.
              </p>
            </div>
            <div className="global-summit-overview-highlights">
              <div className="highlight-card">
                <span className="highlight-number">3,000+</span>
                <span className="highlight-label">Expected Attendees</span>
                <span className="highlight-value">Global Delegation</span>
              </div>
              <div className="highlight-card">
                <span className="highlight-number">56</span>
                <span className="highlight-label">Countries</span>
                <span className="highlight-value">Continental Reach</span>
              </div>
              <div className="highlight-card">
                <span className="highlight-number">$12T</span>
                <span className="highlight-label">Investment Pipeline</span>
                <span className="highlight-value">Green Opportunities</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== KEY THEMES SECTION ===== */}
      <section className="global-summit-section themes-section">
        <div className="global-summit-container">
          <div className="global-summit-header">
            <span className="global-summit-section-badge">AGENDA</span>
            <h2>Summit Key Themes</h2>
            <div className="global-summit-line"></div>
          </div>
          <div className="global-summit-themes-grid">
            <div className="theme-card">
              <div className="theme-icon">⚡</div>
              <h3>Renewable Energy Partnerships</h3>
              <p>Scaling solar, wind, hydro, and green hydrogen projects across critical economic zones in Africa.</p>
            </div>
            <div className="theme-card">
              <div className="theme-icon">🚉</div>
              <h3>Interconnected Smart Infrastructure</h3>
              <p>Investing in intra-continental transport logistics, sustainable rail, and smart cities aligned with the AfCFTA framework.</p>
            </div>
            <div className="theme-card">
              <div className="theme-icon">🔓</div>
              <h3>Innovative Green Finance</h3>
              <p>Unlocking carbon credit pathways, local currency green bonds, and structured sovereign guarantees.</p>
            </div>
            <div className="theme-card">
              <div className="theme-icon">🌿</div>
              <h3>Climate Resilience & Adaptation</h3>
              <p>Building climate-resilient infrastructure and communities across Africa's diverse ecosystems.</p>
            </div>
            <div className="theme-card">
              <div className="theme-icon">💡</div>
              <h3>Technology & Digital Transformation</h3>
              <p>Leveraging AI, IoT, and digital solutions for sustainable development and economic growth.</p>
            </div>
            <div className="theme-card">
              <div className="theme-icon">🤝</div>
              <h3>Public-Private Partnerships</h3>
              <p>Strengthening collaboration between governments, investors, and private sector for impactful projects.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CONTACT SECTION ===== */}
      <section className="global-summit-section contact-section">
        <div className="global-summit-container">
          <div className="global-summit-header">
            <span className="global-summit-section-badge">INQUIRIES</span>
            <h2>Contact & Registration</h2>
            <div className="global-summit-line"></div>
          </div>
          <div className="global-summit-contact-grid">
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <h3>General Inquiries</h3>
              <a href="mailto:aicis@abvig.org">aicis@abvig.org</a>
            </div>
            <div className="contact-card">
              <div className="contact-icon">🏛️</div>
              <h3>Sponsorships</h3>
              <a href="mailto:aicissponsorship@abvig.org">aicissponsorship@abvig.org</a>
            </div>
            <div className="contact-card">
              <div className="contact-icon">📞</div>
              <h3>Phone</h3>
              <a href="tel:+2347032941519">+234 814 263 8552</a>
            </div>
            <div className="contact-card">
              <div className="contact-icon">🌐</div>
              <h3>Website</h3>
              <a href="https://abvig.com" target="_blank" rel="noopener noreferrer">
                www.abvig.com 
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== BOLD REGISTER CTA SECTION ===== */}
      <section className="global-summit-register-cta">
        <div className="global-summit-container">
          <div className="register-cta-content">
            <div className="register-cta-text">
              <span className="register-cta-badge">🚀 JOIN THE MOVEMENT</span>
              <h2>Ready to Shape Africa's Future?</h2>
              <p>
                Secure your place at Africa's premier investment and infrastructure summit. 
                Join 3,000+ global leaders, investors, and policymakers in Abuja.
              </p>
              <div className="register-cta-features">
                <span>✓ 3-Day Summit Access</span>
                <span>✓ VIP Networking Sessions</span>
                <span>✓ Deal-Making Opportunities</span>
                <span>✓ Global Media Exposure</span>
              </div>
            </div>
            <div className="register-cta-button-wrapper">
              <Link to="/policy-agreement" className="register-cta-btn">
                <span className="btn-main-text">Register Now</span>
                <span className="btn-sub-text">Limited Slots Available</span>
                <span className="btn-arrow">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ===== BACK TO HOME ===== */}
      <div className="global-summit-back">
        <Link to="/" className="back-button">← Back to Home</Link>
      </div>
    </div>
  );
};

export default GlobalSummit;